// extracted by mini-css-extract-plugin
export default {"appSubPageWrapperStyles":"appSubPageWrapperStyles_appSubPageWrapperStyles__1zfY8"};